import { request, getInfoLocalStorage, API_URL } from '../../utils/api'
import {
    CONTRATOS_CREATE_LOAD,
    CONTRATOS_CREATE_SUCCESS,
    CONTRATOS_CREATE_ERROR,
    CONTRATOS_LOAD,
    CONTRATOS_SUCCESS,
    CONTRATOS_ERROR,
    CONTRATO_LOAD,
    CONTRATO_ERROR,
    CONTRATO_SUCCESS,
    CONTRATOS_PENDENTES_LOAD,
    CONTRATOS_PENDENTES_ERROR,
    CONTRATOS_PENDENTES_SUCCESS,
    CONTRATOS_RESET,
    CONTRATOS_RENEWAL_ERROR,
    CONTRATOS_RENEWAL_SUCCESS,
    CONTRATOS_RENEWAL_LOAD,
    CLEAR_MESSAGE
} from '../actionTypes'

export const gerarContrato = (form, comprovante, userid, qtMes, paymentMethod) => async dispatch => {
    // Debug - verificar o que está sendo recebido como comprovante
    console.log('Tipo do comprovante:', typeof comprovante);
    console.log('Comprovante:', comprovante);
    
    form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
            try {
                const aux = values.investimento
                var investimento = String(aux).slice(0, -2)+"."+String(aux).slice(-2)
                dispatch(gerarContratoLoad())
                
                // Garantir que o método de pagamento nunca seja undefined
                const method = paymentMethod || values.paymentMethod || 'bank_transfer'
                
                // Verificar se é bank_transfer e se tem comprovante
                if (method === 'bank_transfer' && !comprovante) {
                    dispatch(gerarContratoError('O comprovante de transferência é um documento obrigatório'))
                    return
                }
                
                // Criar um único FormData para todos os campos
                const formData = new FormData()
                
                // Adicionar os campos de texto
                formData.append('id', userid)
                formData.append('tipo', String(values.produto))
                formData.append('investimentoInicial', parseFloat(investimento))
                formData.append('duracao', qtMes)
                formData.append('paymentMethod', method)
                
                // Adicionar campos específicos para bank_transfer
                if (method === 'bank_transfer') {
                    let banco = values.codigoBanco
                    let nomeBanco = banco.replace(/\d+/g, '')
                    nomeBanco = nomeBanco.replace('-', '')
                    let codigoBanco = parseInt(banco, 10)
                    formData.append('banco', nomeBanco)
                    formData.append('codigoBanco', codigoBanco)
                    formData.append('agencia', values.agencia)
                    formData.append('numero', values.conta)
                    
                    // Garantir que o arquivo seja adicionado corretamente
                    if (comprovante) {
                        // Verificar se comprovante é um objeto File
                        console.log('Comprovante é instanceof File?', comprovante instanceof File);
                        
                        try {
                            formData.append('file', comprovante);
                            // Listar conteúdo do FormData para debug
                            console.log('FormData após adicionar file:', 
                                Array.from(formData.entries()).map(e => `${e[0]}: ${e[1]}`));
                        } catch (error) {
                            console.error('Erro ao adicionar arquivo ao FormData:', error);
                        }
                    }
                }
                
                // Debug - mostrar entradas do FormData
                var formEntries = Array.from(formData.entries());
                console.log("formEntries ", formEntries);
                
                // Fazer a requisição
                const req = await fetch(API_URL + 'contracts/request', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${getInfoLocalStorage().token}`
                    }
                })
                const response = await req.json()
                if (response.code === 201) {
                    dispatch(gerarContratoSuccess())
                } else {
                    dispatch(gerarContratoError(response.message))
                }
            } catch(e) {
                console.log(e)
                dispatch(gerarContratoError('Ops! Não conseguimos requisitar seu contrato no momento!'))
            }
        }
    })
}

export const gerarAporte = (form, comprovante, idContrato, tipo, userId) => async dispatch => {
    if (comprovante) {
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                try {
                    dispatch(gerarContratoLoad())
                    const formData = new FormData()
                    formData.append('idContrato', idContrato)
                    formData.append('tipo', tipo)
                    formData.append('valor', values.valor)
                    formData.append('file', comprovante)
                    formData.append('userId', userId)
                    const req = await fetch(API_URL + 'aportes/requestAporte', {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'Authorization': `Bearer ${getInfoLocalStorage().token}`
                        }
                    })
                    const response = await req.json()
                    if (response.code === 51) {
                        dispatch(gerarContratoSuccess())
                    } else if(response.code === 55) {
                        dispatch(gerarContratoError('Você precisa anexar os seus documentos em "Minha Conta" antes de solicitar um contrato de investimento.'))
                    } else {
                        dispatch(gerarContratoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                    }
                } catch(e) {
                    console.log(e)
                    dispatch(gerarContratoError('Ops! Não conseguimos requisitar sua solicitação no momento! Tente novamente dentro de alguns minutos'))
                }
            }
        })
    } else {
        dispatch(gerarContratoError('O comprovante de transferência é um documento obrigatório'))
    }
}

export const gerarResgate = (form, idContrato, tipo, userId) => async dispatch => {
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                try {
                    dispatch(gerarContratoLoad())
                    const response = await request('resgates/requestResgate', 'POST', {
                        idContrato,
                        tipo,
                        valor: values.valor,
                        idCliente: userId,
                        paymentMethod: 'bank' // Definindo bank como método de pagamento padrão
                    })
                    
                    if (response.code === 51) {
                        dispatch(gerarContratoSuccess())
                    } else if(response.code === 55) {
                        dispatch(gerarContratoError('Você precisa anexar os seus documentos em "Minha Conta" antes de solicitar um contrato de investimento.'))
                    } else {
                        dispatch(gerarContratoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                    }
                } catch(e) {
                    console.log(e)
                    dispatch(gerarContratoError('Ops! Não conseguimos requisitar sua solicitação no momento!'))
                }
            }
        })
};

export const gerarRenovacaoTotal = (form, status, idCliente, valorRenovacao, idContrato, duracao) => async dispatch => {
    form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
            try {
                dispatch(gerarRenovacaoLoad())
               
                const infoBanco2 = values.codigoBanco.split(' - ')  
                const response = await request('contracts/createContractRenewal', 'POST', {
                    id: idContrato,
                    idCliente,
                    status,
                    valorRenovacao,
                    duracao, 
                    banco: infoBanco2[1],
                    codigoBanco: infoBanco2[0],
                    agencia: values.agencia,
                    conta: values.conta
                })
                if (response.code == 51) {
                    dispatch(gerarRenovacaoSuccess('Contrato renovado com sucesso!'))
                } else {
                    dispatch(gerarRenovacaoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                }
            } catch(e) {
                console.log(e)
                dispatch(gerarRenovacaoError('Ops! Não conseguimos requisitar sua solicitação!'))
            }
        }
    })
};

export const gerarResgateTotal = (form, idCliente, idContrato) => async dispatch => {
    form.validateFieldsAndScroll(async (err,values) => {
        if(!err) {
            try {
                dispatch(gerarRenovacaoLoad())
                const response = await request('contracts/requestTotalRescue', 'POST', {
                   idCliente: idCliente,
                   id: idContrato
                })
                if (response.code == 51) {
                    dispatch(gerarRenovacaoSuccess('Contrato resgatado com sucesso!'))
                } else {
                    dispatch(gerarRenovacaoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                }

            } catch(e) {
                console.log(e)
                dispatch(gerarRenovacaoError('Ops! Não conseguimos requisitar sua solicitação'))
            }
        }
    })
};

export const gerarRenovacaoComResgate = (form, status, idCliente, valorRenovacao, idContrato, duracao) => async dispatch => {
    form.validateFieldsAndScroll(async (err,values) => {
        if (!err) {
            try {
                dispatch(gerarRenovacaoLoad())

                const infoBanco2 = values.codigoBanco.split(' - ')  
                const response = await request('contracts/createContractRenewalRescue', 'POST', {
                    id: idContrato,
                    idCliente,
                    status,
                    valorRenovacao,
                    duracao, 
                    banco: infoBanco2[1],
                    codigoBanco: infoBanco2[0],
                    agencia: values.agencia,
                    conta: values.conta
                })
                if (response.code == 51) {
                    dispatch(gerarRenovacaoSuccess('Contrato renovado com sucesso!'))
                } else {
                    dispatch(gerarRenovacaoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                }
            } catch(e) {
                console.log(e)
                dispatch(gerarRenovacaoError('Ops! Não conseguimos requisitar sua solicitação!'))
            }
        }
    })
};

export const gerarRenovacaoComAporte = (form, status, idCliente, valorRenovacao, idContrato, duracao, comprovante) => async dispatch => {
    if (comprovante) {
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                try {
                    dispatch(gerarRenovacaoLoad())

                    const infoBanco2 = values.codigoBanco.split(' - ')
                    const formData = new FormData()
                    formData.append('id', idContrato)
                    formData.append('idCliente', idCliente)
                    formData.append('status', status)
                    formData.append('valorRenovacao', valorRenovacao)
                    formData.append('banco', infoBanco2[1])
                    formData.append('codigoBanco', infoBanco2[0])
                    formData.append('agencia', values.agencia)
                    formData.append('conta', values.conta)
                    formData.append('duracao', duracao)
                    formData.append('file', comprovante)

                    var formEntries = Array.from(formData.entries());
                    console.log("formEntries " , formEntries); 

                    const req = await fetch(API_URL + 'contracts/createContractRenewalContribution', {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'Authorization': `Bearer ${getInfoLocalStorage().token}`
                        }
                    })
                    const response = await req.json()
                    if (response.code == 51) {
                        dispatch(gerarRenovacaoSuccess('Contrato renovado com sucesso!'))
                    } else {
                        dispatch(gerarRenovacaoError(response.message || 'Ops! Parece que há alguma inconsistência nos dados!'))
                    }
                } catch (e) {
                    console.log(e)
                    dispatch(gerarRenovacaoError('Ops! Não conseguimos requisitar sua solicitação!'))
                }
            }
        })
    } else {
        dispatch(gerarRenovacaoError('O comprovante de transferência é um documento obrigatório'))
    }
};


export const gerarRenovacaoLoad = () => ({
    type: CONTRATOS_RENEWAL_LOAD
})

export const gerarRenovacaoSuccess = (message) => ({
    type: CONTRATOS_RENEWAL_SUCCESS,
    payload: {
        message
    }
})

export const gerarRenovacaoError = message => ({
    type: CONTRATOS_RENEWAL_ERROR,
    payload: {
        message
    }
})

export const gerarContratoLoad = () => ({
    type: CONTRATOS_CREATE_LOAD
})

export const gerarContratoSuccess = () => ({
    type: CONTRATOS_CREATE_SUCCESS
})

export const gerarContratoError = message => ({
    type: CONTRATOS_CREATE_ERROR,
    payload: {
        message
    }
})

export const loadContratos = (userid, callback) => async dispatch => {
    try {
        dispatch(contratosLoad())
        const response = await request(`contracts/getContratos/${userid}`)
        if (response.code === 51) {
            const { contratos } = response
            if (callback) {
                callback(contratos, () => {
                    dispatch(contratosSuccess(contratos))
                })
            } else {
                dispatch(contratosSuccess(contratos))
            }
        } else {
            dispatch(contratosError())
        }
    } catch(e) {
        console.log(e)
        dispatch(contratosError())
    }
}

export const contratosLoad = () => ({
    type: CONTRATOS_LOAD
})

export const contratosSuccess = contratos => ({
    type: CONTRATOS_SUCCESS,
    payload: {
        contratos: contratos.filter(contrato => contrato.status !== 5)
    }
})

export const contratosError = () => ({
    type: CONTRATOS_ERROR
})

export const loadContrato = idContrato => async dispatch => {
    try {
        if (idContrato) {
            dispatch(contratoLoad())
            const response = await request(`contracts/getContrato/${idContrato}`)
            if (response.code === 51) {
                dispatch(contratoSuccess(response.contrato))
            } else {
                dispatch(contratoError())
            }
        }
    } catch(e) {
        console.log(e)
        dispatch(contratoError())
    }
}

export const contratoLoad = () => ({
    type: CONTRATO_LOAD
})

export const contratoSuccess = contrato => ({
    type: CONTRATO_SUCCESS,
    payload: {
        contrato
    }
})

export const contratoError = () => ({
    type: CONTRATO_ERROR
})

export const loadContratosByStatus = (status) => async dispatch => {
    try {
        dispatch(contratosPendentesLoad())
        const response = await request('contracts/getContratosPendentes/'+status)
        if (response.code === 51) {
            dispatch(contratosPendentesSuccess(response.contratos))
        } else {
            dispatch(contratosPendentesError())
        }
    } catch (e) {
        console.log(e)
        dispatch(contratosPendentesError())
    }
}

export const contratosPendentesLoad = () => ({
    type: CONTRATOS_PENDENTES_LOAD
})

export const contratosPendentesSuccess = contratos => ({
    type: CONTRATOS_PENDENTES_SUCCESS,
    payload: {
        contratos
    }
})

export const contratosPendentesError = () => ({
    type: CONTRATOS_PENDENTES_ERROR
})

export const resetContratoForm = () => ({
    type: CONTRATOS_RESET
})

export const actionClearMessage = () => ({
    type: CLEAR_MESSAGE
})


